import classNames from "classnames";
import ToolCardSimple from "../../../Common/components/ToolCardSimple/ToolCardSimple";
import styles from "./AdminToolButton.module.scss";
import { CapabilityTool } from "../../../Common/models/tools";

export interface AdminToolButtonProps {
  toolKey: string;
  toolName: string;
  toolDisplayName?: string;
  onSelect: (key: string) => void;
  isSelected: boolean;
}

const AdminToolButton = ({
  toolKey,
  toolName,
  toolDisplayName,
  onSelect,
  isSelected,
}: AdminToolButtonProps): JSX.Element => {
  const handleOnClick = () => {
    onSelect(toolKey);
  };
  return (
    <button
      data-testid={`button-${toolKey}`}
      onClick={handleOnClick}
      className={classNames(styles.adminToolButton, {
        [styles["adminToolButton--selected"]]: isSelected,
      })}
    >
      <ToolCardSimple 
        toolKey={toolKey as CapabilityTool} 
        toolName={toolName} 
        toolDisplayName={toolDisplayName || toolName} 
      />
    </button>
  );
};

export default AdminToolButton;
